import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { RandomId, warn } from "@swivl-mono/helpers";
import { NodeInterface, VarKey } from "@swivl-mono/types";
import { Checkbox, Input, Switch } from "@swivl-mono/ui";
import _ from "lodash";
import { FaBars } from "react-icons/fa";

import TabNodeLayoutData, { TabNodeLayoutInterface } from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import "./ProfileCollect.Node.scss";

const ProileCollect = {
  Type: "profileCollect",
  Empty: function () {
    return {
      id: RandomId(6),
      type: ProileCollect.Type,
      items: [
        {
          id: VarKey.UserName,
          label: "Name",
          on: true,
          required: true,
          placeholder: "Enter your name..."
        },
        {
          id: VarKey.UserEmail,
          label: "Email",
          on: true,
          required: true,
          placeholder: "Enter your email..."
        },
        {
          id: VarKey.UserPhoneNumber,
          label: "Phone",
          on: true,
          required: true,
          placeholder: "Enter your phone..."
        },
        {
          id: VarKey.UserPostalCode,
          label: "ZIP Code",
          on: true,
          required: true,
          placeholder: "Enter your ZIP Code..."
        }
      ],
      actionButtonText: "Save",
      savedGoto: null,
      canceledGoto: null,

      handleFreeText: true,
      freeTextGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    let data: TabNodeLayoutInterface = {
      node: node,
      label: "Profile Collect",
      baseWidth: 120,
      tabs: [
        { id: "savedGoto", title: "Saved", source: "savedGoto", target: node.savedGoto },
        { id: "canceledGoto", title: "Canceled", source: "canceledGoto", target: node.canceledGoto }
      ]
    };
    if (node.handleFreeText) {
      data.tabs.push({ id: "freeTextGoto", title: "Unhandled", source: "freeTextGoto", target: node.freeTextGoto });
    }
    return TabNodeLayoutData(data);
  },

  InspectorPanel: class SaveInspectorPanel extends NodePanel {
    onDragEnd = (e: any) => {
      if (!e.destination || !e.source || !e.destination.droppableId || !e.source.droppableId || !e.draggableId) {
        warn("Missing Params");
        return;
      }

      let oldOrder = this.props.node.items;
      if (e.destination.index >= oldOrder.length) {
        var k = e.destination.index - oldOrder.length + 1;
        while (k--) {
          oldOrder.push(undefined);
        }
      }
      oldOrder.splice(e.destination.index, 0, oldOrder.splice(e.source.index, 1)[0]);
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "items", oldOrder);
      this.props.updateNode(node, this.props.node, true);
      return;
    };
    render() {
      const items = this.props.node.items.map((item, index) => {
        return (
          <Draggable key={item.id} draggableId={"draggable_" + item.id} index={index}>
            {(provided, snapshot) => (
              <div className="ProfileCollectItem" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                <div className="handle">
                  <FaBars className="dragHandle" />
                </div>
                <div className="label">{item.label}</div>
                <div className="switch">
                  <Switch
                    on={item.on}
                    name={"items." + index + ".on"}
                    onSet={(on, name) => {
                      let node = JSON.parse(JSON.stringify(this.props.node));
                      _.set(node, name!, on);
                      this.props.updateNode(node, this.props.node, true);
                    }}
                  />
                </div>
                <div className="required">
                  Required
                  <Checkbox
                    checked={item.required}
                    name={"items." + index + ".required"}
                    onCheckedChange={(checked) => {
                      let node = JSON.parse(JSON.stringify(this.props.node));
                      _.set(node, `items.${index}.required`, checked);
                      this.props.updateNode(node, this.props.node, true);
                    }}
                  />
                </div>
              </div>
            )}
          </Draggable>
        );
      });

      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="panel save_panel">
            <InspectorNodeHeader title="Profile Collect" id={this.props.node.id} />

            <Droppable droppableId={"droppable_" + this.props.node.id} type="BUTTON">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={{ backgroundColor: snapshot.isDraggingOver ? "#C3BCB9" : "transparent", borderRadius: 25, padding: "20px 0" }}
                  {...provided.droppableProps}
                >
                  {provided.placeholder}
                  {items}
                </div>
              )}
            </Droppable>
            <label>Unhandled Output</label>
            <Switch
              name="handleFreeText"
              on={this.props.node.handleFreeText}
              onSet={(on, name) => {
                let node = JSON.parse(JSON.stringify(this.props.node));
                _.set(node, name!, on);
                this.props.updateNode(node, this.props.node, true);
              }}
            />

            <Input label="Action Button Text" name="actionButtonText" value={this.props.node.actionButtonText} onChange={this.onChange} />

            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </DragDropContext>
      );
    }
  }
};

export default ProileCollect;
